import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import { academylist, lefthostellist, listhostelentry } from "../../../services/admin";
import { studenttype } from "../../../services/student";
import { roleList } from "../../../services/master";
import moment from "moment";
export const LeftHostel = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [ldate, setLDate] = useState("");
    const [lremark, setLRemark] = useState("");
    const [show, setShow] = useState(false);
    const [slist, setSList] = useState([]);
    const [tlist, setTList] = useState([]);

    const [stype, setSType] = useState("");

    const [wlist, setWlist] = useState([]);
    const [wtype, setWType] = useState("");
    const columnDefs = [
        {
            headerName: "Hostel",
            width: 170,
            field: "hostel_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Room No",
            width: 170,
            field: "room_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Type",
            width: 150,
            field: "hostel_type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            width: 200,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Student Name",
            width: 200,
            field: "student_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            width: 150,
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            width: 150,
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    useEffect(() => {
        funlist("");
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcaID(arr[0]);
                    }
                  }
                 
                }
              }
            });
          }
        roleList().then((res) => {
            if (res.status === true) {
                setWlist(res.data);
            }
        });
        if (localStorage.getItem("ADate") !== '') {
              setLDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
            } else {
              setLDate(moment(new Date()).format("YYYY-MM-DD"));
            }
    }, []);

    function funlist(aid) {
        setSList([]);
        setTList([]);
        const temp1 = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp1.append("academy_id", aid.value);
        }
        temp1.append("type", 2);
        studenttype(temp1).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].username + " (" + res.data.details[i].student_name + ") - " + res.data.details[i].class_name + " - " + res.data.details[i].section_name + " - " + res.data.details[i].gender,
                        });
                    }
                    setSList(arr);
                }

                let arr1 = [];
                if (res.data.teachers.length > 0) {
                    for (let i = 0; i < res.data.teachers.length; i++) {
                        arr1.push({
                            value: res.data.teachers[i].id,
                            label:
                                res.data.teachers[i].username + " (" + res.data.teachers[i].teacher_name + ") - " + res.data.teachers[i].class_name + " - " + res.data.teachers[i].section_name + " - " + res.data.teachers[i].gender,
                        });
                    }
                    setTList(arr1);
                }
            }
        })

        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        temp.append("type", "");
        temp.append("status", 2);

        listhostelentry(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }

    function handleshow() {
        setShow(true);
    }

    function handleclose() {
        setShow(false);
    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            funlist(e);
        } else {
            setAcaID("");
            funlist("");
        }
    }

    function handleStudent(e) {
        if (e !== null) {
            setSType(e);
        } else {
            setSType("");
        }
    }

    function Submitleft(e) {
        e.preventDefault();
        setErrorMessage("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                valid = "Please Select Academy";
                setErrorMessage(valid);
            }
        } else {
            valid = "";
        }

        if (valid === "") {
            if (stype !== "") {
                if (ldate !== "") {
                    if (lremark !== "") {
                        const temp = new FormData();
                        if (localStorage.getItem("Role") === "1" && acaid !== "") {
                            temp.append("academy_id", acaid.value);
                        }
                        temp.append("student_id", stype.value);
                        temp.append("left_date", ldate);
                        temp.append("left_reason", lremark);
                        lefthostellist(temp).then((res) => {
                            if (res.status === true) {
                                handleclose();
                                toast.success(res.message);
                                funlist(acaid);
                            } else {
                                toast.error(res.message);
                            }
                        })
                    } else {
                        setErrorMessage("Please Enter Remark");
                    }
                } else {
                    setErrorMessage("Please Select Date");
                }
            } else {
                setErrorMessage("Please Select Student");
            }
        }

    }

    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Left Hostel</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Hostel Management</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Left Hostel
                        </li>
                    </ol>
                </div>
            </div>
            <Row className="row-sm mx-0 mt-3">
                <Col xxl={12} lg={12} md={12}>
                    <Card className="custom-card overflow-hidden">
                        <Card.Body>
                            <div className="responsive">
                                <div className="res-right">
                                    <a
                                        onClick={handleshow}
                                        variant="success"
                                        type="button"
                                        className="btn my-1 me-2 btn-success tx-teko"
                                    >
                                        {" "}
                                        Add
                                    </a>
                                </div>
                                <div className="ag-theme-alpine ag-style">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>

                            <Modal show={show}>
                                <Modal.Header>
                                    <h4>Add Left Hostel</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        {localStorage.getItem("Role") === "1" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Academy
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={alist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        )}

                                        <Col lg={12} md={12}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Role Type
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={wtype}
                                                    onChange={(e) => setWType(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Role Type
                                                    </option>
                                                    {wlist
                                                        .filter(item => item.id > 2 && item.id < 6)
                                                        .map((item) => {
                                                            return (
                                                                <option value={item.id} key={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            );
                                                        })}

                                                </select>

                                            </div>
                                        </Col>

                                        {wtype == 4 &&
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Student
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Student"
                                                    value={stype}
                                                    options={slist}
                                                    onChange={handleStudent}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        }

                                        {wtype == 5 &&
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Teacher
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Teacher"
                                                    value={stype}
                                                    options={tlist}
                                                    onChange={handleStudent}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        }

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Left Date <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="date"
                                                    value={ldate}
                                                    onChange={(e) => setLDate(e.target.value)}
                                                />
                                            </div>
                                        </Col>


                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Remarks <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <textarea
                                                    rows="3"
                                                    placeholder="Enter Your Remarks"
                                                    value={lremark}
                                                    onChange={(e) => setLRemark(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        {errorMessage !== "" && (
                                            <span className="text-danger">{errorMessage}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <a
                                        onClick={Submitleft}
                                        className="btn btn-next btn-success"
                                        style={{ float: "right" }}
                                    >
                                        Submit
                                    </a>

                                    <a
                                        className="btn btn-next btn-secondary"
                                        style={{ float: "right" }}
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};
